<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('receipts_list_title')}}
                    <v-spacer></v-spacer>
                    <downloadExcel
                            class            = "btn"
                            :fetch           = "fetchAll"
                            :fields          = "excelFields"
                            name="users.xls"
                    >
                        <v-btn
                                icon
                                small
                        >
                            <v-icon right dark>mdi-file-excel</v-icon>
                        </v-btn>
                    </downloadExcel>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('receipts_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <div class="d-flex justify-start mb-6">
                            <v-text-field
                                    v-model="createdAtRengeLable"
                                    label="بازه درخواست"
                                    class="mx-4 pa-1"
                                    id="filters_created_at"
                                    readonly
                                    clearable
                                    @click:clear="resetCreatedAtRenge()"
                            ></v-text-field>
                            <date-picker
                                    v-model="filters.created_at.value"
                                    range
                                    clearable
                                    format="X"
                                    display-format="jMMMM jD"
                                    element="filters_created_at"
                            />
                            <v-select
                                    clearable
                                    v-model="filters.status.value"
                                    label="وضعیت پرداخت"
                                    :items="payStatusOptions"
                                    item-text="value"
                                    item-value="key"
                                    class="mx-4 pa-1"
                            ></v-select>
                        </div>

                    </template>
                    <template #item.reseller_id="{item}">
                        <transition name="fade" mode="out-in">
                            <v-chip
                                    v-if="!item.reseller_id"
                                    color="error"
                                    x-small
                            > -- </v-chip>

                            <v-skeleton-loader
                                    v-else-if="fetchingResellers"
                                    type="text"
                                    class="mt-2"
                            ></v-skeleton-loader>

                            <span v-else>
                                {{ resellers[item.reseller_id].name }}
                            </span>
                        </transition>
                    </template>
                    <template #item.from_date="{item}">
                        {{ getJalaliDate(item.from_date * 1000) }}
                    </template>
                    <template #item.to_date="{item}">
                        {{ getJalaliDate(item.to_date * 1000) }}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.settlement_at="{item}">
                        <v-chip
                                small
                                class="ma-2"
                                :color="item.settlement_at ? 'success' : 'error'"
                                text-color="white"
                        >
                            {{$t(item.settlement_at ? getJalaliDate(item.settlement_at * 1000) : $t('not_paid'))}}
                        </v-chip>
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'SettlementRequestDetails', params : { id : item.id } }"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-eye</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('details')}}</span>
                        </v-tooltip>

                    </template>
                </v-data-table>
            </v-card>
        </div>
    </section>
</template>

<script>
    import { mapActions, mapState, mapGetters } from 'vuex';

    import RequestList from "../services/RequestList";
    import Service from "../services/SettlementRequestsService";
    import downloadExcel from "vue-json-excel";

    import config from "@/config";
    export default {
        components: {
            downloadExcel
        },
        created() {
            this.syncResellers();
            this.fetch();
        },
        computed: {
            ...mapState({
                resellers: state => state.resellers.resellers
            }),
            ...mapGetters({
                fetchingResellers: 'resellers/fetching'
            }),
            createdAtRengeLable(){
                if(!this.filters.created_at.value) return null;

                let fromLabel = this.filters.created_at.value[0] ? `${this.getJalaliDate(this.filters.created_at.value[0] * 1000, 'jD jMMM jYY')} ~ ` : '';
                let toLabel = this.filters.created_at.value[1] ? `${this.getJalaliDate(this.filters.created_at.value[1] * 1000, 'jD jMMM jYY')}` : '';

                return [fromLabel, toLabel].join(' ').trim();
            },
        },

        watch: {
            '$route'(){
                this.fetch();
            },
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(typeof filter.value != 'undefined'){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            },
            options: {
                handler(options) {
                    let query = Object.assign(JSON.parse(JSON.stringify(this.$route.query)),{
                        page: options.page,
                        count : options.itemsPerPage
                    });

                    this.$router.push({
                        query : query
                    }).catch(err => err);
                },
                deep: true,
            }
        },
        data() {
            return {
                loading : false,
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('reseller'),
                        value: 'reseller_id',
                    },
                    {
                        text: this.$t('from_date'),
                        value: 'from_date',
                    },
                    {
                        text: this.$t('to_date'),
                        value: 'to_date',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at'
                    },
                    {
                        text: this.$t('settlement_status'),
                        value: 'settlement_at'
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions'
                    }
                ],
                excelFields : {
                    'ایجاد شده در' : {
                        field: 'created_at',
                        callback: (value) => {
                            return this.getJalaliDate(value * 1000, 'jYYYY-jMM-jDD HH:mm');
                        }
                    },
                    "مبلغ کل" : 'sub_total',
                    'مالیات' : 'tax_due',
                    'جمع کل' : 'total_due',
                    'وضعیت پرداخت' : {
                        callback: (item) => {
                            return this.$t(item.paid_at ? 'paid' : 'not_paid');
                        }
                    },
                    'توضیحات' : 'description'

                },
                filters : {
                    created_at : {
                        column_name : 'created_at',
                        operand : 'Between',
                        value : undefined
                    },
                    status : {
                        column_name : 'status',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                options: {
                    page : 1,
                    itemsPerPage : config.itemsPerPage
                },
                footerProps: {'items-per-page-options': [5, 10,15, 30, 50, 100]},
                items : [],
                item : null,
                total : 0,
                page : 1,
                fetchCount : config.fetchCount
            }
        },
        methods: {
            ...mapActions({
                syncResellers: 'resellers/sync'
            }),
            async fetch() {
                this.loading = true;
                this.options.page = parseInt(this.$route.query.page || this.options.page);
                this.options.itemsPerPage = parseInt(this.$route.query.count || this.options.itemsPerPage);

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(this.options.page, this.options.itemsPerPage);
                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.settlement_requests;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async fetchAll() {
                this.loading = true;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');

                try {
                    let {data} = await Service.list(requestList);
                    return data.value.settlement_requests;
                } finally {
                    this.loading = false;
                }
            },
            getStatusColor(receipt){
                let color = null;
                switch (receipt.status){
                    case 'pending' :
                        color = 'warning';
                        break;
                    case 'paying' :
                        color = null;
                        break;
                    case 'failed' :
                        color = 'error';
                        break;
                    case 'paid' :
                        color = 'success';
                        break;
                }
                return color;
            },
            resetCreatedAtRenge() {
                this.filters.created_at.value = undefined;
            }
        }

    }
</script>